<template>
  <div>
    <!-- <v-card
      class="mx-4 mt-4"
      v-if="isStaff"
      shaped
      elevation="12"
      max-width="344"
      outlined
    >
      <v-list-item three-line>
        <v-autocomplete
          prepend-inner-icon="search"
          v-model="selectedProduct"
          :items="products"
          solo-inverted
          flat
          hide-details
          label="Select Product"
           dark
        
          @change="getSelectedProduct()"
        ></v-autocomplete>
        <v-btn
          class="mx-4"
          :style="getThemeStyle"
          @click="openGlobalDialogSlot()"
          ><v-icon>mdi-plus</v-icon></v-btn
        >
      </v-list-item>
    </v-card> -->
    <!-- <CardAlert class="mt-4 mx-4" color="#0277BD"> -->
    <v-toolbar dark :style="{ background: '#FF9800', color: 'white' }">
      <!-- <v-toolbar-title>{{ getCompanyLabels.products }}</v-toolbar-title> -->
      <v-autocomplete
        clearable
        dense
        v-model="selectedProduct"
        :items="products"
        class="ml-4"
        flat
        hide-no-data
        hide-details
        :label="'Select ' + getCompanyLabels.products"
        solo-inverted
        @change="getSelectedProduct()"
      ></v-autocomplete>
      <v-btn
        color="#E65100"
        fab
        small
        :class="isMobile ? 'mb-6 ml-2' : 'ml-2'"
        dark
        @click="openGlobalDialogSlot()"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- </CardAlert> -->

    <GlobalDialogSlot
      :title="title"
      :dialog="dialog"
      @close-dialog="dialog = false"
    >
      <CreateAndAddProductToReceivings
        @product-created="getNewProduct"
        @exist="title = 'Item Exist'"
      ></CreateAndAddProductToReceivings>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import productsAndServicesJs from "@/plugins/productsAndServices";
import CreateAndAddProductToReceivings from "@/modules/ProductsAndServices/CreateAndAddProductToReceivings.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  name: "Product",
  components: { GlobalDialogSlot, CreateAndAddProductToReceivings },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  async mounted() {
    this.$store.commit("setLoader", true);
    await this.getAllProductsInStock();
    this.$store.commit("setLoader", false);
  },
  data: () => ({
    title: "Create Product",
    products: [],
    selectedProduct: null,
    dialog: false,
  }),
  methods: {
    async getAllProductsInStock() {
      const products = await productsAndServicesJs.getAllProductsInStock();

      if (products.length > 0) {
        products.forEach((product) => {
          this.products.push({
            text: `${product.name} [${product.code}]`,
            value: product,
          });
        });
      }
    },
    getSelectedProduct() {
      this.$emit("product-selected", this.selectedProduct);
    },
    openGlobalDialogSlot() {
      this.title = "Create " + this.getCompanyLabels.products;
      this.dialog = true;
    },
    getNewProduct(product) {
      this.products.push({
        text: `${product.name} [${product.code}]`,
        value: product,
      });
      this.selectedProduct = product;
      this.$emit("product-selected", this.selectedProduct);
      this.dialog = false;
    },
  },
};
</script>

<style></style>
